import { ArrowDown } from "lucide-react";

const PRODUCT_IMAGE =
  "https://customer-assets.emergentagent.com/job_f2dda134-0cc2-4fcf-9e09-51f400de7a69/artifacts/8qciinr0_hf_20260607_172728_75ebbe7e-205c-412f-849e-7374c3d32450.png";

export default function HeroSection({ onCTA }) {
  return (
    <section
      data-testid="hero-section"
      className="relative py-16 md:py-24 lg:py-32 overflow-hidden"
      style={{ backgroundColor: "#1e1e1f" }}
    >
      {/* Subtle gradient orb */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full opacity-[0.07]"
        style={{ background: "radial-gradient(circle, #7C3AED 0%, transparent 70%)" }}
      />

      <div className="max-w-6xl mx-auto px-5 md:px-12 relative z-10">
        {/* Single column above the fold */}
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          {/* Overline */}
          <span
            className="inline-block uppercase tracking-[0.2em] text-xs font-semibold mb-6"
            style={{ color: "#b0b0b5", fontFamily: "'Inter', sans-serif" }}
          >
            The daily planner that lets you start over without starting over
          </span>

          {/* Headline */}
          <h1
            className="text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight mb-6"
            style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
            data-testid="hero-headline"
          >
            Stop adding to your planner graveyard. Get the undated daily tracker
            that expects you to miss a day.
          </h1>

          {/* Sub-headline */}
          <p
            className="text-base md:text-lg leading-relaxed mb-10 max-w-2xl"
            style={{ fontFamily: "'Inter', sans-serif", color: "#b0b0b5" }}
            data-testid="hero-subheadline"
          >
            Organize your days without the shame of empty calendar pages. Print
            it out or use it on your tablet in under five minutes.
          </p>

          {/* Product Image */}
          <div className="w-full max-w-md mb-10">
            <img
              src={PRODUCT_IMAGE}
              alt="The Soft Reset - Daily Planner Preview"
              className="w-full h-auto drop-shadow-2xl"
              data-testid="hero-product-image"
            />
          </div>

          {/* CTA Button */}
          <button
            onClick={onCTA}
            data-testid="hero-cta-button"
            className="group relative px-8 py-4 rounded-lg text-white font-semibold text-lg transition-all duration-200 hover:scale-[1.02] active:scale-[0.99] cursor-pointer"
            style={{
              fontFamily: "'Inter', sans-serif",
              background: "linear-gradient(135deg, #7C3AED, #6D28D9)",
              boxShadow: "0 0 20px rgba(124, 58, 237, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 0 30px rgba(124, 58, 237, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 0 20px rgba(124, 58, 237, 0.3)";
            }}
          >
            Get The Soft Reset for $17
            <ArrowDown className="inline-block ml-2 w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
          </button>

          {/* Microcopy */}
          <p
            className="mt-4 text-xs"
            style={{ color: "#b0b0b5", fontFamily: "'Inter', sans-serif" }}
            data-testid="hero-microcopy"
          >
            One-time payment. Yours forever. No sneaky subscriptions.
          </p>
        </div>
      </div>
    </section>
  );
}
